import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';

const AlternateDatePicker2 = ({ label, id, name, value, onChange }) => {
  const [dateValue, setDateValue] = useState(null);

  useEffect(() => {
    // Initialize dateValue from prop value
    if (value instanceof Date && !isNaN(value)) {
      setDateValue(value);
    } else {
      setDateValue(null);
    }
  }, [value]);

  const handleDateChange = (date) => {
    setDateValue(date);
    onChange({
      target: {
        name,
        value: date ? formatDate(date) : '', // Send formatted date or empty string
      },
    });
  };

  const formatDate = (date) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const isLabelActive = dateValue !== null;

  return (
    <div className="relative h-9 w-full border">
      <DatePicker
        selected={dateValue}
        onChange={handleDateChange}
        dateFormat="yyyy-MM-dd"
        autoComplete="off"
        className={{
            input: `block h-9  w-full border-b-2 bg-transparent text-gray-900 focus:ring-0 focus:border-blue-500 
                    ${isLabelActive ? 'pt-6' : 'pt-3'}`
          }}
      />
      <label
        htmlFor={id}
        className={`absolute left-3 px-1 transition-all duration-200 ease-in-out bg-white pointer-events-none ${
          isLabelActive ? '-top-3.5 text-sm' : 'top-2.5 text-base text-gray-400'
        }`}
      >
        {label}
      </label>
    </div>
  );
};

export default AlternateDatePicker2;
